import { addDays, startOfDay, endOfToday } from 'date-fns';

const defineds = {
  endOfToday: endOfToday(),
  oneYearAgo: startOfDay(addDays(new Date(), -366))
};

export const lastWeek = {
  label: 'Last Week',
  tag: 'lastWeek',
  range: () => ({
    startDate: defineds.oneYearAgo,
    endDate: defineds.endOfToday
  })
};
